module.exports = __webpack_public_path__ + "static/media/zaspana-prva-ali-utrujena-zadnja.9f25b5e7.png";